import { render, staticRenderFns } from "./MainLoader.vue?vue&type=template&id=1b79fe88&scoped=true"
import script from "./MainLoader.vue?vue&type=script&lang=js"
export * from "./MainLoader.vue?vue&type=script&lang=js"
import style0 from "./MainLoader.vue?vue&type=style&index=0&id=1b79fe88&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b79fe88",
  null
  
)

export default component.exports